import { Button } from './button'

export type SoftDeleteConfirmDialogProps = {
  open: boolean
  /** Entity type label, e.g. "reviewer" or "case". */
  entityLabel: string
  /** Display name of the specific record being deleted. */
  itemName: string
  onCancel: () => void
  onConfirm: () => void
  confirming?: boolean
}

export function SoftDeleteConfirmDialog({
  open,
  entityLabel,
  itemName,
  onCancel,
  onConfirm,
  confirming = false,
}: SoftDeleteConfirmDialogProps) {
  if (!open) {
    return null
  }

  const normalizedLabel = entityLabel.trim()

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="soft-delete-confirm-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="soft-delete-confirm-title" className="font-display text-xl font-bold">
          Delete {normalizedLabel}?
        </h2>

        <p className="mt-3 text-sm text-ink-700">
          Are you sure you want to delete{' '}
          <span className="font-semibold text-ink-900">&ldquo;{itemName}&rdquo;</span>?
        </p>

        <div className="mt-4 rounded-md border border-parch-200 bg-parch-50 px-3 py-2 text-sm text-ink-600">
          This is a soft delete. The record is not permanently removed and can be restored later.
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onCancel} disabled={confirming}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? 'Deleting…' : 'Delete'}
          </Button>
        </div>
      </div>
    </div>
  )
}
